import request from '@/utils/request'

// 获取旧号码的验证码
export function getOldSMS() {
    return request({
        url: '/agent/personal/changeBind/sendCode',
        method: 'post',
    })
}

// 获取新号码的验证码
export function getNewSMS(mobile) {
    return request({
        url: `/agent/personal/send-code/${mobile}`,
        method: 'post',
    })
}

// 校验旧号码的验证码是否正确
export function checkOldSMS(code) {
    return request({
        url: `/agent/personal/currentCheckSmsCode/${code}`,
        method: 'get',
    })
}

// 确认换绑
export function bindNewMobile(data) {
    return request({
        url: `/agent/personal/bind-mobile`,
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/updateMobile.js